// extracted by mini-css-extract-plugin
export default {"wrapper":"tT-z","availablePromoMessagesLabel":"uT-z","promoMessageList":"vT-z","promoMessage":"wT-z","appliedPromoMessage":"xT-z","promoMessageAmount":"yT-z"};